module.exports = __webpack_public_path__ + "static/img/design-ssbanner.7205278.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/works/design-ssbanner.jpg
 ** module id = 15
 ** module chunks = 1
 **/